import { render, staticRenderFns } from "./CafeMenu.vue?vue&type=template&id=4e1bda62&scoped=true&"
import script from "./CafeMenu.vue?vue&type=script&lang=js&"
export * from "./CafeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1bda62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e1bda62', component.options)
    } else {
      api.reload('4e1bda62', component.options)
    }
    module.hot.accept("./CafeMenu.vue?vue&type=template&id=4e1bda62&scoped=true&", function () {
      api.rerender('4e1bda62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/common/CafeMenu.vue"
export default component.exports